import http from "@/api/http.js";

export function getProductsStats(fromDate, toDate) {
  return http
    .get(`/products/stats?fromDate=${fromDate}&toDate=${toDate}`)
    .then(res => {
      return res.data;
    });
}

export function getProductsStatsCompare(
  fromDate1,
  toDate1,
  fromDate2,
  toDate2
) {
  return http
    .get(
      `/products/stats_compare?fromDate1=${encodeURIComponent(
        fromDate1
      )}&toDate1=${encodeURIComponent(toDate1)}&fromDate2=${encodeURIComponent(
        fromDate2
      )}&toDate2=${encodeURIComponent(toDate2)}`
    )
    .then(res => {
      return res.data;
    });
}

export function getProducts(params) {
  return http.get("/products/catalog", { params }).then(res => res.data);
}

export function getProduct(nkrCode, params) {
  return http
    .get(`/products/catalog_single/${encodeURIComponent(nkrCode)}`, { params })
    .then(res => res.data);
}

export function updateProduct(id, data) {
  return http.put(`/products/catalog/${id}`, data).then(res => res.data);
}

export function getInventoryByProduct(nkrCode, params) {
  return http
    .get(`/warehouse/inventory_by_product/${encodeURIComponent(nkrCode)}`, {
      params
    })
    .then(res => res.data);
}

export function getMovementHistory(params) {
  return http.get("/warehouse/movements", { params }).then(res => res.data);
}

export function adjustStock(data) {
  return http.post("/warehouse/adjust_stock", data).then(res => res.data);
}

export function getProductLines(nkrCode) {
  return http
    .get(`/products/catalog_single/${encodeURIComponent(nkrCode)}`, {
      params: { include_lines: true }
    })
    .then(res => res.data);
}

export function catalogSync(updatedSince) {
  const params = {};
  if (updatedSince) params.updated_since = updatedSince;
  return http.get("/products/catalog_sync", { params }).then(res => res.data);
}
